import { get, merge } from 'lodash';
import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState as requestInitialState,
} from '../../utils/redux';

const paginationInitialState = {
  member: {
    offset: 0,
    limit: 10,
  },
  moderator: {
    offset: 0,
    limit: 10,
  },
};

const initialState = {
  ...requestInitialState,
  pagination: paginationInitialState,
};

const request = {
  endpoint: 'participated_communities',
  type: 'get',
  slug: [
    {
      type: 'payload.query',
      queryParameter: 'type',
      selector: 'type',
    },
    {
      type: 'payload.query',
      queryParameter: 'limit',
      selector: 'limit',
    },
    {
      type: 'payload.query',
      queryParameter: 'offset',
      selector: 'offset',
    },
  ],
};

export const consts = createReqConsts('communities', 'userCommunities', [
  'UPDATE_TOTAL_UNREAD_COUNT',
]);
export const paginatedConsts = createReqConsts(
  'communities',
  'paginatedUserCommunities',
  ['LOAD_NEXT_COMMUNITIES', 'UPDATE_PAGINATION_PARAMETERS'],
);

export const actions = createActions(consts);
export const paginatedActions = createActions(paginatedConsts);

export const watcher = createReqWatcher(consts, actions, request);
export const paginatedWatcher = createReqWatcher(
  paginatedConsts,
  paginatedActions,
  request,
);

const defaultRequestReducer = createReqReducer(consts);

export default (state = initialState, action) => {
  const { payload } = action;

  switch (action.type) {
    case consts.SUCCEED: {
      return Object.assign(
        {},
        state,
        requestInitialState,
        {
          succeed: true,
        },
        payload,
      );
    }
    case consts.UPDATE_TOTAL_UNREAD_COUNT: {
      const { communityId, updatePostCounter, removeCounter } = payload;
      const prevMember = get(state, 'memberCommunities', []);
      const prevModerator = get(state, 'moderatorCommunities', []);
      const newList = currentList => {
        return currentList.map(item => {
          if (get(item, 'id') === communityId) {
            const counter = get(
              item,
              'communityMemberChatroom.totalUnreadCount',
            );
            const postsCounter = get(item, 'totalPosts');
            const totalPostsCounter = updatePostCounter
              ? postsCounter + 1
              : postsCounter;
            const totalUnreadCounter = removeCounter ? 0 : counter + 1;
            return {
              ...item,
              totalPosts: totalPostsCounter,
              communityMemberChatroom: {
                ...item.communityMemberChatroom,
                totalUnreadCount: totalUnreadCounter,
              },
            };
          }
          return item;
        });
      };
      return {
        ...state,
        memberCommunities: newList(prevMember),
        moderatorCommunities: newList(prevModerator),
      };
    }
    case paginatedConsts.SUCCEED: {
      const { memberCommunities = [], moderatorCommunities = [] } = payload;

      const prevMember = get(state, 'memberCommunities', []);
      const prevModerator = get(state, 'moderatorCommunities', []);

      return Object.assign({}, state, requestInitialState, {
        succeed: true,
        memberCommunities: prevMember.concat(memberCommunities),
        moderatorCommunities: prevModerator.concat(moderatorCommunities),
      });
    }
    case paginatedConsts.UPDATE_PAGINATION_PARAMETERS: {
      const { type, offset, limit } = payload;

      return merge({}, state, {
        pagination: {
          [type]: { offset, limit },
        },
      });
    }
    default: {
      return defaultRequestReducer(state, action);
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/communities/userCommunities.js